import React, { useCallback, useState } from "react"
import { useLocation } from "react-router-dom"

import { Formik, Form } from "formik"
import { Fieldset } from "components"

import * as yup from "yup"

import { useAuth } from "hooks/useAuth"

const passwordResetModel = {
  password: "",
  passwordConfirmation: "",
}

const passwordResetSchema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password is too short - should be 8 chars minimum.")
    .matches(/[a-zA-Z]/, "Password can only contain Latin letters."),
  passwordConfirmation: yup
    .string()
    .required("Password confirmation is required")
    .test("passwords-match", "Passwords must match", function (value) {
      return this.parent.password === value
    }),
})

const Page = ({ children }) => (
  <div className="w-full min-h-screen flex justify-center items-center">
    {children}
  </div>
)

const PasswordResetPage = () => {
  const { restPassword } = useAuth()
  const location = useLocation()
  const [isSubmitted, setIsSubmitted] = useState(false)

  const formikProps = {
    initialValues: { ...passwordResetModel },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: passwordResetSchema,
    onSubmit: useCallback(async (values, { setSubmitting }) => {
      try {
        setSubmitting(true)

        await restPassword({
          code: location.state.oobCode,
          password: values.password,
        })

        setIsSubmitted(true)
      } catch (e) {
        setSubmitting(false)
        console.error("Error", e)
        // const errors = e.graphQLErrors.map(v => v)
        // setFieldError("server", errors)
      }
    }),
  }

  return (
    <Page>
      {isSubmitted ? (
        <div className="max-w-sm mx-auto bg-white shadow-lg p-6 relative z-50">
          <div className="w-full">
            <p>
              Please check your email for further instructions. Sometimes spam
              filters block automated emails. If you do not find the email in
              your inbox, please check your spam filter or bulk email folder.
            </p>
          </div>
        </div>
      ) : (
        <Formik {...formikProps}>
          {({ errors }) => (
            <Form className="w-full h-full">
              <div className="max-w-sm mx-auto bg-white shadow-lg p-6 relative z-50 rounded-lg">
                <header className="text-center mb-6">
                  <h1 className="text-xl text-gray-900 leading-none">
                    Reset your password
                  </h1>

                  <p className="text-sm text-gray-500 leading-normal mt-2">
                    Please enter new password below
                  </p>
                </header>

                <div className="px-2 py-3">
                  <Fieldset
                    label="Password"
                    name="password"
                    type="password"
                    placeholder="Type your new password"
                  />
                </div>

                <div className="px-2 py-3">
                  <Fieldset
                    label="Password retype"
                    name="passwordConfirmation"
                    type="password"
                    placeholder="Retype your new password"
                  />
                </div>

                {/* {errors && errors.server && (
              <Box width={1} py={2} mt={2}>
                <Message color="error">
                  <p style={{ padding: "0", margin: "0" }}>
                    Invalid credentials.
                  </p>
                  <p style={{ padding: "0", margin: "0" }}>
                    Please enter a correct username and password.
                  </p>
                </Message>
              </Box>
            )} */}

                <button type="submit" className="btn-submit">
                  Reset password
                </button>
              </div>
            </Form>
          )}
        </Formik>
      )}

      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="/images/s-migaj-Yui5vfKHuzs-unsplash.jpg"
          alt=""
        />
      </div>
    </Page>
  )
}

export default PasswordResetPage
